//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import searchFilter from '~/mixins/search/search-filter'

export default {
  name: 'FilterRadio',
  mixins: [searchFilter]
}
